"use strict";

/**
 * @classdesc
 * FachDB-Featureobjekt einer Transaktions-Funktion des FeatureServices.
 *
 * @class
 * @extends gc.gis.service.feature.AbstractTransactionFeature
 * @memberof gc.gis.service
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.service.feature.TransactionFachDBFeature = function()
{
	gc.gis.service.feature.AbstractTransactionFeature.call(this);

	/**
	 * Fachbezug Geometrie
	 * @type {Object[]}
	 * @private
	 */
	this._geometryList = [];

	/**
	 * Fachbezug Adresse
	 * @type {Object[]}
	 * @private
	 */
	this._adressList = [];

	/**
	 * Fachbezug Flurstück
	 * @type {Object[]}
	 * @private
	 */
	this._landparcelList = [];

	/**
	 * Fachbezug Media.
	 * @type {Object[]}
	 * @private
	 */
	this._mediaList = [];

};
gc.gis.service.feature.TransactionFachDBFeature.prototype = Object.create(gc.gis.service.feature.AbstractTransactionFeature.prototype);

/**
 * Liefert die Koordinatenbezüge.
 *
 * @return {Object[]}
 */
gc.gis.service.feature.TransactionFachDBFeature.prototype.getGeometryList = function ()
{
	return this._geometryList;
};

/**
 * Setzt die Koordinatenbezüge.
 *
 * @param {Object[]} geometryList
 * @return {gc.gis.service.feature.TransactionFachDBFeature}
 */
gc.gis.service.feature.TransactionFachDBFeature.prototype.setGeometryList = function (geometryList)
{
	this._geometryList = geometryList;
	return this;
};

/**
 * Fügt einen Koordinatenbezug hinzu.
 *
 * @param {Object} geometry
 * @return {gc.gis.service.feature.TransactionFachDBFeature}
 */
gc.gis.service.feature.TransactionFachDBFeature.prototype.addGeometry = function (geometry)
{
	this._geometryList.push(geometry);
	return this;
};

/**
 * Liefert die Adressbezüge.
 *
 * @return {Object[]}
 */
gc.gis.service.feature.TransactionFachDBFeature.prototype.getAddressList = function ()
{
	return this._adressList;
};

/**
 * Setzt die Adressbezüge.
 *
 * @param {Object[]} adressList
 * @return {gc.gis.service.feature.TransactionFachDBFeature}
 */
gc.gis.service.feature.TransactionFachDBFeature.prototype.setAddressList = function (adressList)
{
	this._adressList = adressList;
	return this;
};

/**
 * Liefert die Adressbezüge.
 *
 * @return {Object[]}
 */
gc.gis.service.feature.TransactionFachDBFeature.prototype.getLandparcelList = function ()
{
	return this._landparcelList;
};

/**
 * Setzt die Adressbezüge.
 *
 * @param {Object[]} landparcelList
 * @return {gc.gis.service.feature.TransactionFachDBFeature}
 */
gc.gis.service.feature.TransactionFachDBFeature.prototype.setLandparcelList = function (landparcelList)
{
	this._landparcelList = landparcelList;
	return this;
};

/**
 * Liefert die Medienbezüge.
 *
 * @return {Object[]}
 */
gc.gis.service.feature.TransactionFachDBFeature.prototype.getMediaList = function ()
{
	return this._mediaList;
};

/**
 * Setzt die Medienbezüge.
 *
 * @param {Object[]} mediaList
 * @return {gc.gis.service.feature.TransactionFachDBFeature}
 */
gc.gis.service.feature.TransactionFachDBFeature.prototype.setMediaList = function (mediaList)
{
	this._mediaList = mediaList;
	return this;
};